<template>
  <div ref="container" :class="['date-picker-container', {'fixed': fixedDatepicker}]">
    <div :class="['datepicker', { 'reduce-padding': showPreviousArrow }]" v-if="hasDates">
      <div class="button button-left" @click="goToPrevious" v-show="showPreviousArrow">&#9001;</div>
      <ul class="date-bar" :style="gridTemplateColumnsStyle">
        <li v-for="date in dates" :key="date.toISOString()" :class="{ weekend: isWeekend(date) }">
          <span class="date">{{ date.format("DD.MM") }}</span>
          <span class="day">{{ date.format("ddd") }}</span>
        </li>
      </ul>
      <div class="button button-right" @click="goToNext" v-show="showNextArrow">&#9002;</div>
    </div>
</div>
</template>

<script>
import moment from 'moment';

export default {
  name: "quotes-datepicker",
  data() {
    return {
      date: null,
      columns: 0,
      diffDays: 0,
      cellsToFit: 0,
      goToNextCounter: 1,
    };
  },
  props: {
    period: {
      type: [String, Number],
      default: "0",
    },
    start: {
      type: Array,
      default: () => []
    },
    currentLocalize: {
      type: String,
      default: () => 'ru'
    },
    getShowQuotes: {
      type: Boolean,
      default: false
    },
    fixedDatepicker: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.calculateCellsToFit();
    window.addEventListener('resize', this.calculateCellsToFit);
  },
  updated() {
   this.calculateCellsToFit();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateCellsToFit);
  },
  computed: {
    showPreviousArrow() {
      if (!this.date) return false;

      const startDate = moment(this.start[0], "DD/MM/YYYY");
      return this.date.isAfter(startDate);
    },
    showNextArrow() {
      if (!this.date || this.diffDays) return false;

      const newDate = this.date.clone().add(this.cellsToFit, 'days');
      const endDate = moment(this.start[0], "DD/MM/YYYY").add(this.period, 'days');
      if (newDate.isSame(endDate)) return false;

      return this.period > this.columns && +this.period !== (this.columns * this.goToNextCounter);
    },
    hasDates() {
      const start = Array.isArray(this.start) ? this.start[0] : null;
      return !!(start && parseInt(this.period))
    },
    dates() {
      const period = this.columns;
      const localize = this.currentLocalize === 'ua' ? 'ru' : this.currentLocalize
      const datesNormal = Array.from({ length: period }, (_, i) => this.date.clone().add(i, 'days').locale(localize));
      const datesISO = Array.from({ length: period }, (_, i) => {
        return this.date.clone().add(i, 'days').toISOString()
      });

      this.$emit('send-dates-iso', datesISO)

      return datesNormal
    },
    gridTemplateColumnsStyle() {
      return {
        'grid-template-columns': `repeat(${this.columns}, 48px)`,
      };
    },
  },
  methods: {
    isDateWithinPeriod(newDate) {
      const startDate = moment(this.start[0], "DD/MM/YYYY");
      const endDate = moment(this.start[0], "DD/MM/YYYY").add(this.period, 'days');

      return newDate.isSameOrAfter(startDate) && newDate.isSameOrBefore(endDate);
    },
    calculateDates(newDate) {
      if (!newDate) return;
      const period = this.columns;
      const localize = this.currentLocalize === 'ua' ? 'ru' : this.currentLocalize;
      const datesNormal = Array.from({ length: period }, (_, i) => newDate.clone().add(i, 'days').locale(localize));
      const datesISO = datesNormal.map(date => date.toISOString());

      this.$emit('send-dates-iso', datesISO);
      return datesNormal;
    },
    calculateCellsToFit() {
      const cellWidth = 48; // Размер ячейки
      const containerWidth = this.$refs.container.offsetWidth - 430; // Ширина контейнера за вычитом отступов
      this.cellsToFit = Math.floor(containerWidth / cellWidth);

      if (this.diffDays === 0) {
          this.columns = this.period < this.cellsToFit ? this.period : this.cellsToFit;
      } else if (this.diffDays < 0) {
          if(!this.start) return;
          const endDate = moment(this.start[0], "DD/MM/YYYY").add(this.period, 'days');
          const datePlusCellsToFit = this.date.clone().add(this.cellsToFit, 'days');
          const diff = endDate.diff(datePlusCellsToFit, 'days');

          if (diff <= 0) {
            this.columns = this.cellsToFit - Math.abs(diff)
          } else {
            this.columns = Math.abs(this.diffDays);
          }
      } else if (this.diffDays > 0) {
          this.columns = 0;
      }
    },
    goToPrevious() {
      if (!this.date) return;
      const starDate = moment(this.start[0], "DD/MM/YYYY");
      const switchDate = this.date.clone().subtract(this.cellsToFit, 'days');
      const newDate = switchDate.isBefore(starDate) ? starDate : switchDate;

      if (this.isDateWithinPeriod(newDate)) {
        this.date = newDate;
        this.calculateCellsToFit();
        this.goToNextCounter--;
        this.diffDays = 0;
      }
    },
    goToNext() {
      if (!this.date) return;

      const newDate = this.date.clone().add(this.columns, 'days');
      const endDate = moment(this.start[0], "DD/MM/YYYY").add(this.period, 'days');
      const newDatePlusColumns = newDate.clone().add(this.columns, 'days');

      const diffInDays = endDate.diff(newDatePlusColumns, 'days'); // Получаем разницу между датами
      this.diffDays = diffInDays < 0 ? diffInDays : 0;

      if (this.isDateWithinPeriod(newDate)) {
        this.date = newDate;
        this.calculateCellsToFit();
        this.goToNextCounter++;
      }
    },
    isWeekend(date) {
      // 6 = суббота, 0 = воскресенье
      return date.day() === 6 || date.day() === 0;
    },
  },
  watch: {
    start: {
      handler(val) {
        if (!Array.isArray(val)) return
        this.date = moment(val[0], "DD/MM/YYYY");
      },
      immediate: true,
    },
    period: {
      handler(val) {
        if (!val) return
        this.diffDays = 0;
        if (Array.isArray(this.start)){
          this.date = moment(this.start[0], "DD/MM/YYYY");
        }
      },
      immediate: true,
    },
    date: {
      handler(newDate) {
        this.calculateDates(newDate);
      },
      immediate: true,
    },
    getShowQuotes() {
      this.calculateCellsToFit()
    }
  },
};
</script>

<style>
.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
}

.datepicker {
  position: relative;
  background-color: var(--white-color);
  padding: 10px 80px 10px 340px;
  display: flex;
  align-items: center;
  column-gap: 10px;
  justify-content: start;
}

.date-bar {
  list-style-type: none;
  display: grid;
  grid-template-columns: repeat(30, 48px);
  border: 1px solid var(--lighten-3-color);
  border-radius: 3px;
}

.date-bar li {
  padding: 5px 0px;
  text-align: center;
}

.date-bar li:not(:last-child) {
  border-right: 1px solid var(--lighten-3-color);
}

.weekend .date, .weekend .day {
  color: red;
}

.date, .day {
  display: block;
}

.date::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: var(--lighten-3-color);
}

.datepicker .button {
  position: sticky;
  font-size: 25px;
  font-weight: 700;
  cursor: pointer;
}

.reduce-padding {
  padding: 10px 80px 10px 320px;
}
</style>